import { HomePage } from './home/home';
import { PostPage } from './post/post';
import { LoginPage } from './login/login'; 
import { WritePage } from './write/write';
import { NotFoundExceptionPageComponent } from './not-found-exception-page/not-found-exception-page.component';
import { ErrorPage } from './error-page/error-page.component';



/*
  Generated class for the FirebaseProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export {
	HomePage,
	PostPage,
	LoginPage,
	WritePage,
	NotFoundExceptionPageComponent,
	ErrorPage
}